// tenant api
import loadJsonAwsApiGenerator from '../../tenant/api/loadJsonAwsApiGenerator.api.tenant';

const getCollectionDataApi = (collection) =>
  loadJsonAwsApiGenerator(`collections/${collection}`)();

export default getCollectionDataApi;
